import React from 'react'
import {
    CCard,
    CCardBody,
    CCardHeader,
    CBadge,
    CFade
  } from '@coreui/react'
  import {
    CChartDoughnut,
} from '@coreui/react-chartjs'
import CIcon from '@coreui/icons-react'
import { SET_SHOW_INFOBOX } from '../../redux/actions'
import { useDispatch } from 'react-redux'

const InfoBox = (props) => {

    var dispatch = useDispatch();
    var isLeadership = false;

    var candidateNames = [];
    var candidateVotes = [];
    var candidateNamesParties = [];
    var candidateParties = [];
    var candidateColors = [];
    const [showCard, setShowCard] = React.useState(true)

    if (props.hasOwnProperty('Candidates')) {
        for (var i=0;i<props['Candidates'].length;i++) {
            candidateNames.push(props['Candidates'][i].name);
            candidateNamesParties.push(props['Candidates'][i].name+" ("+props['Candidates'][i].party+")");
            candidateVotes.push(props['Candidates'][i].votes);
            if (props['Candidates'][i].party === "Liberal") {
                candidateColors.push('#ff0000');
            } else if (props['Candidates'][i].party === "Conservative") {
                candidateColors.push('#0000ff');
            } else if (props['Candidates'][i].party === "Progressive Conservative") {
                candidateColors.push('#0000ff');
            } else if (props['Candidates'][i].party === "NDP-New Democratic Party") {
                candidateColors.push('#ff7200');
            } else if (props['Candidates'][i].party === "NDP") {
                candidateColors.push('#ff7200');
            } else if (props['Candidates'][i].party === "N.D.P") {
                candidateColors.push('#ff7200');
            } else if (props['Candidates'][i].party === "Bloc Québécois") {
              candidateColors.push('#0b9fd6');
            } else if (props['Candidates'][i].party.startsWith("Bloc ")) {
                candidateColors.push('#0b9fd6');              
            } else if (props['Candidates'][i].party === "Canadian Alliance") {
                candidateColors.push('#5ba963');
            } else if (props['Candidates'][i].party === "Maverick Party") {
              candidateColors.push('#84ba8a');
            } else if (props['Candidates'][i].party === "Libertarian") {
              candidateColors.push('#f1b92b');
            } else if (props['Candidates'][i].party === "Green Party") {
                candidateColors.push('green');
            } else if (props['Candidates'][i].party === "Parti Rhinocéros Party") {
              candidateColors.push('#ef0885');
            } else if (props['Candidates'][i].party === "Marijuana Party") {
              candidateColors.push('#325311');
            } else if (props['Candidates'][i].party === "Free Party Canada") {
              candidateColors.push('#f5dba5');
            } else if (props['Candidates'][i].party === "Animal Protection Party") {
              candidateColors.push('#d4fbed');
            } else if (props['Candidates'][i].party === "VCP") {
              candidateColors.push('yellow');
            } else if (props['Candidates'][i].party === "Marxist-Leninist") {
              candidateColors.push('#a30000');
            } else if (props['Candidates'][i].party === "Communist") {
              candidateColors.push('#c47373');
            } else if (props['Candidates'][i].party === "Christian Heritage Party") {
              candidateColors.push('#7b2548');
            } else if (props['Candidates'][i].party === "People's Party") {
                candidateColors.push('#800080');
            } else if (props['Candidates'][i].party === "PPC") {
                candidateColors.push('#800080');
            } else if (props['Candidates'][i].party === "People's Party - PPC") {
              candidateColors.push('#800080');
            } else if (props['Candidates'][i].party === "Canadian Economic Party") {
              candidateColors.push('#6aff00');
            } else if (props['Candidates'][i].party === "Canadians' Choice Party") {
              candidateColors.push('#cb2058');
            } else if (props['Candidates'][i].party === "Consensus Ontario") {
              candidateColors.push('#29a9e2');
            } else if (props['Candidates'][i].party === "Cultural Action Party") {
              candidateColors.push('#651a94');
            } else if (props['Candidates'][i].party === "Cultural Action Party") {
              candidateColors.push('#3b2f75');
            } else if (props['Candidates'][i].party === "Go Vegan") {
              candidateColors.push('#238300');
            } else if (props['Candidates'][i].party === "Multicultural Party") {
              candidateColors.push('#bfe50e');
            } else if (props['Candidates'][i].party === "New People's Choice Party") {
              candidateColors.push('#570878');
            } else if (props['Candidates'][i].party === "Northern Ontario Party") {
              candidateColors.push('#a2001c');
            } else if (props['Candidates'][i].party === "Ontario Alliance") {
              candidateColors.push('#5bc0de');
            } else if (props['Candidates'][i].party === "Ontario Moderate Party") {
              candidateColors.push('#00a9e5');
            } else if (props['Candidates'][i].party === "Ontario Party") {
              candidateColors.push('#122d54');
            } else if (props['Candidates'][i].party === "Ontario Social Reform Party") {
              candidateColors.push('#2b2193');
            } else if (props['Candidates'][i].party === "Party for People with Special Needs") {
              candidateColors.push('#602a35');
            } else if (props['Candidates'][i].party === "Party of Objective Truth") {
              candidateColors.push('#380039');
            } else if (props['Candidates'][i].party === "Pauper Party") {
              candidateColors.push('#ffff0d');
            } else if (props['Candidates'][i].party === "People's Political Party") {
              candidateColors.push('#709ba7');
            } else if (props['Candidates'][i].party === "Stop Climate Change") {
              candidateColors.push('#1db28d');
            } else if (props['Candidates'][i].party === "Stop the New Sex-Ed Agenda") {
              candidateColors.push('#dd001e');
            } else if (props['Candidates'][i].party === "Trillium Party") {
              candidateColors.push('#713b8a');
            } else if (props['Candidates'][i].party === "Independent") {
                candidateColors.push('#888888');
            } else {
                candidateColors.push('black');
            }
            candidateParties.push(props['Candidates'][i].party);
        }
    }

    if (props.hasOwnProperty('rounds')) {
      isLeadership = true;
      var cv = Object.entries(props['properties'].Rounds[props['roundnum']].candidate_votes);
      var exhausted = props['properties'].Rounds[props['roundnum']].exhausted;
      for (var i=0;i<cv.length;i++) {
          candidateNames.push(cv[i][0]);
          candidateVotes.push(cv[i][1]);
          if (cv[i][0] === "Erin O'Toole") {
              candidateColors.push('#7AB7F5');
          } else if (cv[i][0] === "Leslyn Lewis") {
              candidateColors.push('#8BF571');
          } else if (cv[i][0] === "Peter MacKay") {
              candidateColors.push('#b871f5');
          } else if (cv[i][0] === "Derek Sloan") {
              candidateColors.push('#F571D8');
          } else {
              candidateColors.push('black');
          }
          //candidateParties.push(props['Candidates'][i].party);
      }
  }

    return (
      <CFade in={showCard}>
        <CCard style={{position:'absolute', float:'right', zIndex:1000, width:400, height:260, right:10, bottom:10}}>
          {isLeadership ? (
          <CCardHeader>
            {props['properties']['Riding Name'] !== undefined ? props['properties']['Riding Name'] : ""}
            <div className="card-header-actions">
              <span style={{cursor:'pointer'}} className="card-header-action" onClick={() => dispatch({type: SET_SHOW_INFOBOX, showInfobox: false})}>
                <CIcon name="cil-x-circle" />
              </span>
            </div>
            <CBadge className="mr-1 float-right" color="secondary">exhausted: {exhausted}</CBadge>
          </CCardHeader> 
          ) : (
            <CCardHeader>
            {props['Riding Name'] !== undefined ? (props['Poll ID'] !== undefined ? "" : props['Riding Name']) : ""}
            {props['Poll ID'] !== undefined ? "Poll ID: "+props['Poll ID'] : ""} {props['Poll name'] !== undefined ? "("+props['Poll name']+")" : ""} {props['mw'] !== "" && props['mw'] !== undefined && props['mw'] !== '""' ? <CBadge className="mr-1 float-right" color="secondary">merge with: {props['mw']}</CBadge> : ""}
            <div className="card-header-actions">
              <span style={{cursor:'pointer'}} className="card-header-action" onClick={() => dispatch({type: SET_SHOW_INFOBOX, showInfobox: false})}>
                <CIcon name="cil-x-circle" />
              </span>
            </div>
          </CCardHeader>
          ) }

          <CCardBody>
          <CChartDoughnut
            datasets={[
              {
                backgroundColor: candidateColors,
                data: candidateVotes
              }
            ]}
            labels={candidateNames ? candidateNames : []}
            options={{
              tooltips: {
                enabled: true
              }
            }}
          />
          </CCardBody>
        </CCard>
      </CFade>
    )
  }
  
  export default InfoBox;